import './GaugeResponsiveLabel.css';
export var responsiveLabelContainer = '_1f44lry0-2-0-1';